<template>
  <div id="app">
    <!-- Component rendered by Vue Router -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

</style>
